module.exports = __webpack_public_path__ + "static/media/10 Minuts Review Meeting 18 May.c9cf105d.pdf";